export interface registrationPayload {
  name: string
  phone: string
  email: string
  password: string
  type: string
  loginDevice?: string
  courses?: string
  plan?: string
  otp?: string
  paid?: boolean
  trial?: boolean
}

export type deviceType = 'mobile' | 'website'

export interface PrivateCoursesPayload {
  amount: string
  coachingCentreId: string
  label: string
  value: string
  selected?: boolean
}

interface RegisterState {
  isLoading: boolean
  showOtpModel: boolean
  userDetails: registrationPayload
  privateCourses: Array<PrivateCoursesPayload>
  orderId: string
  registrationComplete: boolean
  hasError?: boolean
}

export const initialState: RegisterState = {
  isLoading: false,
  showOtpModel: false,
  userDetails: {
    name: '',
    phone: '',
    email: '',
    password: '',
    type: 'student',
    otp: 'unverified',
    paid: false,
    loginDevice: ''
  },
  orderId: '',
  privateCourses: [],
  registrationComplete: false,
  hasError: false
}
